
import Chemistry_tamil_1 from '../../images/information/Chemistry_tamil_1.jpg';
import Chemistry_sinhala_1 from '../../images/information/Chemistry_sinhala_1.jpg';
import Chemistry_english_1 from '../../images/information/Chemistry_english_1.jpg';
import Chemistry_tamil_2 from '../../images/information/Chemistry_tamil_2.jpg';
import Chemistry_sinhala_2 from '../../images/information/Chemistry_sinhala_2.jpg';
import Chemistry_english_2 from '../../images/information/Chemistry_english_2.jpg';
import Phy_english_1 from '../../images/information/Phy_english_1.jpg';
import Phy_sinhala_1 from '../../images/information/Phy_sinhala_1.jpg';
import Phy_tamil_1 from '../../images/information/Phy_tamil_1.jpg';
import Logic_english_1 from '../../images/information/Logic_english_1.jpg';
import Logic_sinhala_1 from '../../images/information/Logic_sinhala_1.jpg';
import Logic_tamil_1 from '../../images/information/Logic_tamil_1.jpg';

//language - 1(Tamil) , 2(English) , 3(Sinhala)

const images = {
    "Chemistry" : {
        1 : [Chemistry_tamil_1,Chemistry_tamil_2],
        2 : [Chemistry_english_1,Chemistry_english_2],
        3 : [Chemistry_sinhala_1,Chemistry_sinhala_2]
    } , 
    "Physics" : {
        1 : [Phy_tamil_1],
        2 : [Phy_english_1],
        3 : [Phy_sinhala_1]
    },
    "Logic & Scientific Method" : {
        1 : [Logic_tamil_1],
        2 : [Logic_english_1],
        3 : [Logic_sinhala_1]
    }
}
export {images};